export const environment = {
  production: true,
  apiUrl: 'https://api.bofynd.se/api',
  mainUrl: 'https://www.bofynd.se',
  imageBase: 'https://api.bofynd.se/images/properties/',
  avatarBase: 'https://api.bofynd.se/images/properties/avatar',
  companyLogoBase: 'https://api.bofynd.se/images/properties/company-logotype',
};
